export default {
  props: {
    for: {
      type: String,
      require: true
    },
    label: {
      type: String,
      default: ''
    },
    labelStyle: {
      type: Object
    },
    optional: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: [Array, String],
      default: ''
    },
    errorStyle: {
      type: Object
    }
  },

  computed: {
    forAttr () {
      return this.for
    },

    errorMessage () {
      return typeof this.errors === 'string'
        ? this.errors
        : Array.isArray(this.errors) && this.errors.length > 0
          ? this.errors[0]
          : null
    }
  }
}
